import $ from 'jquery';
import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import multiMonthPlugin from '@fullcalendar/multimonth'
import deLocale from '@fullcalendar/core/locales/de';

// Calender from FullCalendar
// https://fullcalendar.io

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$('.event-calendar').each(function () {

    const $calendar = $(this);

    // Collect events from the DOM

    const events = [];
    const $eventsContainer = $calendar.find('.event-list-events');
    const $events = $eventsContainer.find('.event-list-event');

    $events.each(function () {
        const $event = $(this);
        events.push({
            title: $event.data('title'),
            start: $event.data('start'),
        });
    });

    $eventsContainer.remove();


    // Initialize the calendar
    const calendar = new Calendar($calendar[0], {
        plugins: [dayGridPlugin, timeGridPlugin, multiMonthPlugin],
        locale: deLocale,
        initialView: 'dayGridMonth',
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'multiMonthYear,dayGridMonth,timeGridWeek'
        },
        eventSources: [
            {
                events: events,
                // color: 'black',
                // textColor: 'red'
            },
        ],
    });
    calendar.render();


});

